module.exports = __webpack_public_path__ + "img/cable-gray.f378e5a8.svg";